import { request, API_URL, SHIPMENT_TRACKING_API_URL, PROJECT_URL, getAuthToken } from "./axiosInstance";
import axios from "axios";
// Create an order

// Place an order via custom/v1/orders.
//
// Previously POSTed to wc/v3/orders, which requires `publish_shop_orders` — an
// admin capability the `customer` role does not have. That call only ever worked
// because the storefront sent it as a full Administrator. The replacement endpoint
// is scoped to the authenticated customer and, importantly, does not trust the
// client for customer_id, line prices, or the shipping total.
export async function createAnOrder(userInfo) {
    const token = await getAuthToken();
    try {
        const cartItems = JSON.parse(localStorage.getItem('cart')) || [];
        if (!cartItems.length) {
            throw new Error('Cart is empty');
        }

        // Only send line_items if the caller has not already supplied them
        // (Checkout.jsx builds its own, including variation ids).
        const payload = userInfo.line_items
            ? userInfo
            : {
                ...userInfo,
                line_items: cartItems.map((item) => ({
                    product_id: item.id,
                    quantity: item.quantity,
                })),
            };

        const response = await axios.post(
            `${PROJECT_URL}wp-json/custom/v1/orders`,
            payload,
            { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('Error creating order:', {
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to create order');
    }
}


// Get all orders
export async function getAllOrderData(page = 1, per_page = 10) {
    try {
        const response = await request('GET', `${API_URL}/orders`, {}, 
             {
      params: {
        page,
        per_page,
        orderby: "date",
        order: "desc",
      },
    }
        );

        return {
            data: response.data,
            total: response.headers?.['x-wp-total'] || response.length,
            totalPages: response.headers?.['x-wp-totalpages'] || 1,
        };
    } catch (error) {
        console.error('Error fetching orders:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch orders');
    }
}

// Fetch orders by user ID
export async function getOrdersByUserId(userId) {
    try {
        return await request('GET', `${API_URL}/orders`, {}, { customer: userId });
    } catch (error) {
        console.error('Error fetching orders by user ID:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch orders by user ID');
    }
}

// Get all orders
{/** export async function getAllOrders() {
    try {
        const response = await request('GET', `${API_URL}/orders`);
        return {
            data: response.data,
            total: response.headers?.['x-wp-total'] || response.length,
            totalPages: response.headers?.['x-wp-totalpages'] || 1,
        };
    } catch (error) {
        console.error('Error fetching all orders:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch all orders');
    }{ page, per_page: perPage }
}*/}
export async function getAllOrders(page = 1, perPage = 10) {
    try {
        const response = await request('GET', `${API_URL}/orders`, {}, { page, per_page: perPage });
        return {
            data: response.data,
            total: response.headers?.['x-wp-total'] || response.data.length,
            totalPages: response.headers?.['x-wp-totalpages'] || 1,
        };
    } catch (error) {
        console.error('Error fetching all orders:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch all orders');
    }
}



// Get single order data
export async function getSingleOrderData(orderId) {
    try {
        return await request('GET', `${API_URL}/orders/${orderId}`);
    } catch (error) {
        console.error('Error fetching single order:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch single order');
    }
}

// Delete order by ID
export async function deleteOrderById(orderId) {
    try {
        return await request('DELETE', `${API_URL}/orders/${orderId}`, {}, { force: true });
    } catch (error) {
        console.error('Error deleting order:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to delete order');
    }
}

// Update order
/*export async function updateOrderById(orderId, data) {
    try {
        return await request('PUT', `${API_URL}/orders/${orderId}`, data);
    } catch (error) {
        console.error('Error updating order:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to update order');
    }
}*/





// Update an order. Uses the caller's own JWT — no consumer key.
//
// This previously sent a hardcoded WooCommerce consumer key/secret, which shipped in
// the public JS bundle and granted write access to every order in the store to anyone
// who read it (SEC-6). Those credentials must be treated as compromised.
//
// Requires `edit_shop_orders`, i.e. administrator or shop_manager — so this is for the
// admin dashboard (DshOrders.jsx). Customers cancelling their own order must use
// cancelOwnOrder() below; the `customer` role has no order-write capability.
export async function updateOrderById(orderId, data) {
    try {
        const response = await request('PUT', `${API_URL}/orders/${orderId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating order:', {
            orderId,
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to update order');
    }
}

// Cancel an order belonging to the signed-in customer.
//
// Backed by POST custom/v1/orders/{id}/cancel, which verifies the order belongs to the
// authenticated user and only ever sets status to `cancelled`. This exists because the
// `customer` role deliberately lacks `edit_shop_orders`, so a customer cannot PUT to
// wc/v3/orders — and granting that capability, or shipping a key that bypasses it,
// would let any customer edit any order.
export async function cancelOwnOrder(orderId) {
    const token = await getAuthToken();
    try {
        const response = await axios.post(
            `${PROJECT_URL}wp-json/custom/v1/orders/${orderId}/cancel`,
            {},
            { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        console.error('Error cancelling order:', {
            orderId,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(
            error.response?.data?.message || 'Could not cancel this order. Please contact support.'
        );
    }
}





// Track order
export const fetchTrackingInfo = async (orderId) => {
    try {
        const response = await request('GET', `${SHIPMENT_TRACKING_API_URL}/orders/${orderId}/shipment-trackings`);
        return response;
    } catch (error) {
        console.error('Error fetching tracking info:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status,
        });
        throw new Error(error.response?.data?.message || 'Failed to fetch tracking info');
    }
};